<script lang="ts" setup>
import {
  type Collections,
  type CollectionItems,
} from '~/utils/generated/graphql'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
import Loading from '~/assets/images/loading.svg?component'

const props = defineProps<{
  items: CollectionItems | Collections
  paging?: Paging
  hasMore?: boolean | undefined
  loading?: boolean | undefined
  loadMore?: (() => void) | undefined
  showIndexes?: boolean | undefined
}>()

const currentItems = ref(props.items.items)
watch(() => (props.items), (items) => {
  currentItems.value = items.items
})
</script>

<template>
  <div
    v-if="items"
    class="max-w-[1271px] w-full m-auto"
  >
    <hr class="m-auto md:hidden mt-4 mx-4 border-neutral-300">
    <div class="w-full flex flex-wrap md:gap-[35.5px] max-[1271px]:justify-items-center max-[1271px]:justify-center">
      <CollectionsGridItem
        v-for="(item, index) in currentItems"
        :key="item.id"
        :index="showIndexes ? index + 1 : undefined"
        :item="item"
        :lazy="index > 3"
      />
    </div>
    <div
      v-if="hasMore"
      class="mt-8 ms-4 me-4 md:me-0 md:ms-0 gap-4 justify-center"
    >
      <PButton
        id="load-more"
        type="button"
        class="text-blurple-600 hover:bg-blurple-600 hover:text-white stroke-blurple-600 hover:stroke-white font-[600] w-full md:w-[150px] font-sans text-sm px-5 py-2.5 justify-center me-2 rounded-lg border border-blurple-600"
        :disabled="loading"
        :click="loadMore"
      >
        <div class="inline-flex place-items-center">
          <Loading
            v-if="loading"
            class="w-4 h-4 me-2 animate-spin"
          />
          {{ loading ? $t('loading') : $t('loadMore') }}
        </div>
      </PButton>
    </div>
  </div>
</template>
